import { images } from '../constants';

const home = [
    {  
        id: 1,
        image: images.home1,
        title: 'Guatemalan',
        content: 'Guatemalan coffee is a medium roast featuring initial notes of milk chocolate that gracefully transition into a sweet orange mild citrus finish. This creates an absolutely delectable cup.',
    },
    {
        id: 2,
        image: images.home2,
        title: 'Colombian',
        content: 'Colombian coffee is known for its smooth, mild flavor and balanced acidity. It offers a rich aroma and a hint of nuttiness, making it a favorite among coffee enthusiasts.',
    },
    { 
        id: 3,
        image: images.home3,
        title: 'Costa Rican Tarrazu',
        content: 'Costa Rican Tarrazu coffee is known for its bright acidity and full-bodied flavor. It offers a rich aroma with hints of citrus and a smooth, clean finish.',
    },
    { 
        id: 4,
        image: images.home3,
        title: 'Samutran',
        content: 'Samutran coffee is known for its rich, full-bodied flavor with a hint of spice. It offers a unique aroma and a smooth, satisfying finish.',  
    },
    { 
        id: 5,
        image: images.home3,
        title: 'Mexican',
        content: 'Mexican coffee is known for its light to medium body and bright acidity. It offers a smooth, mild flavor with hints of chocolate and nuts, making it a delightful choice for any coffee lover.',  
    },
    { 
        id: 6,
        image: images.home3,
        title: 'Tanzanian',
        content: 'Tanzanian coffee is known for its bright acidity and full-bodied flavor. It offers a rich aroma with hints of citrus and a smooth, clean finish.',  
    },
    {  
        id: 7,
        image: images.home1,
        title: 'Ethiopian Yirgacheffe',
        content: 'With hints of bright citruses like sweet tangerine and lime, the acidity level is powerful and bright, while ending with a dry lemon tea finish.',
    },
    {
        id: 8,
        image: images.home2,
        title: 'Kenyan',
        content: 'This African coffee is bright, complex, and exceptionally sweet. It is low in acid and has a lovely floral fragrance.',
    },
    { 
        id: 9,
        image: images.home3,
        title: 'Perubian',
        content: 'This coffee has a rich unique depth of flavor with medium acidity. You can truly distinguish the spiced cinnamon flavor at first sip transitioning to a caramelized sweetness in the body with a lingering citrus finish.',  
    },
    { 
        id: 10,
        image: images.home3,
        title: 'Papua New Guinea',
        content: 'This is more than just coffee-it\'s an experience that stands apart. This coffee is smooth and notably sweet with a medium body and creamy feel. The initial taste reflects candied walnut, chocolate, and spices. It ends with a dark and fruity, remarkably clean finish. 12oz $3.95 16oz $4.95',  
    },
    { 
        id: 11,
        image: images.home3,
        title: 'Haitian',
        content: 'Haitian coffee is celebrated for its unique flavor profile. This rare organic coffee boasts of spicy cinnamon notes and a sweet herbaceousness ending with a rich plum flavor.',  
    },
    { 
        id: 12,
        image: images.home3,
        title: 'Honduras',
        content: 'An excellent nutty and bright coffee. With additional notes of milk chocolate, you get a smooth and sugary-sweet body with a lemon wedge finish.',  
    },    
    {  
        id: 13,
        image: images.home1,
        title: 'Brazillian',
        content: 'Brazilian coffee is one of the most famous coffees in the world. This medium-dark roasted Brazilian coffee has a dry cocoa taste that is notable throughout the cup and finishes with a savory walnut flavor.',
    },
    {
        id: 14,
        image: images.home2,
        title: 'Dominican Republic',
        content: 'Dominican coffee delivers a stunning delicious cup, characterized by its sweet, well-rounded flavor and robust finish. It’s notably low in acidity and has notes of sweet apple, grape, and vanilla throughout.',
    },
    { 
        id: 15,
        image: images.home3,
        title: 'Uganda',
        content: 'This coffee showcases the bold and intense flavors developed during the longer roasting process. It\'s strong and smooth with very mild acidity and surprisingly sweet, dark chocolate notes.',  
    },
    { 
        id: 16,
        image: images.home3,
        title: 'Indian',
        content: 'Indian Monsoon Malabar is a unique coffee with unmatched smoothness and a mellow flavor. Notes of baker\'s chocolate come through predominantly and finishes with a mild, creamy flavor.',  
    },
    { 
        id: 17,
        image: images.home3,
        title: 'Vietnamese',
        content: 'Vietnamese coffee is a bold intense dark roast coffee. It is a favorite among most coffee connoisseurs. It’s tipically very strong, slightly sweet and has an earthy flavor. It is often roasted with butter giving it a unique taste.',  
    },
    { 
        id: 18,
        image: images.home3,
        title: 'Cuban Espresso',
        content: 'One of the most popular coffees in the world known for its high caffeine content making it ideal for those seeking an energizing brew without bitterness.This coffee offers a bold and robust flavor with notes of dark chocolate and black cherry.',  
    },
    {  
        id: 19,
        image: images.home1,
        title: 'Italian Espresso',
        content: 'Dark Roast with notes of red fruits and a dense, bittersweet body. Italian Roast Espresso is rich and tangy. This artisan blend Italian roast coffee is sure to please any dark roast lover.',
    },
    {
        id: 20,
        image: images.home2,
        title: 'Black Knight',
        content: 'Looking for a coffee that\'s truly bold? Meet the Black Knight. This is a dangerously dark roast that delivers on flavor. This isn\'t your average dark roast. It’s a blend with notorious notes of tropical plantains and an intense, caramelized sugar.',
    },
    { 
        id: 21,
        image: images.home3,
        title: 'Classic Medium Roast',
        content: 'This Premium Medium Roast is a favorite Artisan Blend! Bold but not too bold, balanced, a little sweet, and a super clean finish. This one is a treat for every coffee lover, and we think you\'ll agree!',  
    },
    { 
        id: 22,
        image: images.home3,
        title: 'Breakfast Blend',
        content: 'Designed to delight, not overwhelm. This isn\'t just any light roast; it\'s an artisan blend meticulously crafted to offer a flavorful and rich experience that feels wonderfully balanced on your palate.',  
    },
    { 
        id: 23,
        image: images.home3,
        title: 'Jamaican Me Crazy',
        content: 'Fresh Roasted coffee taken to the next level of flavor. With Jamaican Me Crazy Flavored Coffee you’ll taste sweet caramel, vanilla bean, and coffee liqueur flavors blending deliciously. It\’s paradise in a cup!',  
    },
    { 
        id: 24,
        image: images.home3,
        title: 'Hawaiian Macadamia Nut',
        content: 'Sweet. Buttery. Nutty! With a hint of something special - is it coconut sugar? This deliciously smooth Hawaiian Macadamia Nut may not be able to physically transport you to the islands, but your tastebuds will almost certainly be fooled.',  
    }, 
];

export default home;
